<template>
  <div class="boxes">
    <h3><Icon type="md-bookmarks" />考核指标<slot name="right"></slot></h3>
    <Row>
      <Col span="6">
        <ly-form-item label="数据合格率：" lw='6'>{{item.passRate}}%</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="轨迹完整率：" lw='6'>{{item.cpteRate}}%</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="附件丢失率：" lw='6'>{{item.lossRate}}%</ly-form-item>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      item: {
        passRate: 0,
        cpteRate: 0,
        lossRate: 0,
      },
    };
  },
  methods: {
    getData(v) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countOpt",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.item = res.data.data;
      });
    },
  },
  mounted() {},
};
</script>
<style>
#kdkdkdk {
  width: 100%;
  height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReports/kaohezhibiao.vue